import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { requireUnconfirmedReview } from '../lib/router/route-guards';
import { pickUnconfirmedListSearch } from '../lib/router/unconfirmedListSearch';

const UnconfirmedGroupsPage = lazy(() =>
  import('../pages/admin/unconfirmed-groups/UnconfirmedGroupsPage').then((m) => ({
    default: m.UnconfirmedGroupsPage,
  })),
);

export const Route = createFileRoute('/unconfirmed-groups')({
  beforeLoad: ({ context }) => requireUnconfirmedReview(context.queryClient),
  // The page reads its filters through nuqs; declaring them here lets other
  // routes link back to the list with the filters still applied.
  validateSearch: (search: Record<string, unknown>) => pickUnconfirmedListSearch(search),
  component: () => (
    <Suspense
      fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%', transform: 'translateX(-50%)' }} />}
    >
      <UnconfirmedGroupsPage />
    </Suspense>
  ),
});
